import React, { Component } from 'react';
import { connect } from 'react-redux';
import { errorActions, fetchMyArticles, selecteArticle, applyArticle, applyArticleGroup } from '../../actions';
import { FormGroup, Input, Modal, Label} from 'reactstrap';
import myFetchWithId from '../../helpers/myFetch';
import { withRouter } from 'react-router-dom';
import Loader from 'react-loader-advanced';
import { CreateItem, UpdateItem, DeleteItem } from '../../helpers/crud';

const mapStateToProps = (state) => {
	return {
		myArticleGroups: state.search.savedDocs,
		selectedArticle: state.search.selectedDocs
	};
};
const mapDispatchToProps = dispatch => {
	return {
		fetchMyArticles: () => dispatch(fetchMyArticles()),
		selecteArticle: (index, array) => dispatch(selecteArticle(index, array)),
		applyArticle: (block, article) => dispatch(applyArticle(block, article)),
		// applyArticleTag: (name, block) => dispatch(applyArticleTag(name, block)),
		updateError: (err) => dispatch(errorActions.update(err)),
		applyArticleGroup:(block, articles) =>dispatch(applyArticleGroup(block, articles))
	};
};
const keywordApi = '/v5/lowi/profile/doc';
const spinner = <div className="lds-ripple"><div></div><div></div></div>;

class MyArticleComponent extends Component {
  constructor(props) {
    super(props);
		this.apply = this.apply.bind(this);
		this.select = this.select.bind(this);
    this.cancel = this.cancel.bind(this);
		this.setType = this.setType.bind(this);
		this.toggleEmptyAlert = this.toggleEmptyAlert.bind(this);

    this.state = {
		currArticles: [],
		emptyAlert: false,
		currId: '',
		currName: '',
		currArticle: false,
		loading: false,
		filterType: 1,
		currDocIndex: 0
    }
  }


	//select and get the article list from the group
	select(id, tIndex) {
		const normalFetch = myFetchWithId('', true);
		this.setState({loading: true});
		try {
			normalFetch(`${keywordApi}/get_doclist`, {id: id})
			.then( data => {
				this.props.selecteArticle(tIndex, this.props.selectedArticle);
				const decodeName = data.response_data ? decodeURIComponent(data.response_data.name) : null;

				if (data.response_data && data.response_data.list) {
					const savedArticles = data.response_data.list;
					const articles = [];
					for(let i = 0; i < savedArticles.length; i++) {
						// keep the artical title short enough
						let articleTitle = '';
						if (savedArticles[i].title && savedArticles[i].title.length > 20) {
							articleTitle = savedArticles[i].title.substr(0, 19) + ' ...';
						} else {
							articleTitle = savedArticles[i].title;
						}
						articles.push({
							id: savedArticles[i].id, 
							name: articleTitle, 
							url: savedArticles[i].doc
						});
					}
					this.setState({
						currId: data.response_data.id,
						currName: decodeName,
						currArticles: articles,
						loading: false,
						currDocIndex: tIndex
					});
				} else {
					this.setState({
						currName: decodeName,
						currArticles: [],
						loading: false,
						currDocIndex: tIndex
					})
				}
			})
		} catch (err) {
				this.props.updateError(err);
				this.setState({loading: false})
		}
	}


	// ACTION WITH SEARCH
	apply() {
		const block = this.state.filterType===1 ? false : true;
		const articleArray = this.state.currArticles;

		const articleGroup =this.props.myArticleGroups.filter(item => item.id === this.state.currId)[0]
		console.log(articleGroup)

		if (articleArray.length ===0) {
			this.setState({emptyAlert: true});
		} else {
			articleArray.forEach((obj)=>{
				this.props.applyArticle(block,{title: obj.name, url: obj.url});
			})
			// this.props.applyArticleTag(this.state.currName, block);
			this.props.closeModal();
		}

		// if(articleArray.length !== 0){
		// 	this.props.applyArticleGroup(block,{...articleGroup,docs:articleArray})
		// 	this.props.closeModal();
		// }else{
		// 	this.setState({emptyAlert: true});
		// }
	}
	
	setType(type) {
		this.setState({ filterType: type });
	}
	toggleEmptyAlert() {
		this.setState(prevState => ({emptyAlert: !prevState.emptyAlert}));
	}
	cancel() {
		this.props.closeModal();
	}

	// COMPONENT LIFE CURCLE
	componentDidMount() {
		this.props.fetchMyArticles();
	}
  render() {
    return (
      <div className='ad-search-popup'>

        <div className="popup-modal-header">
          <h3>您儲存的文章</h3>
        </div>

				<div className="popup-modal-content">
					<div className='author-controller'>
						<CreateItem
							apiCall={`${keywordApi}/create_doclist`}
							fetchItem={this.props.fetchMyArticles}
							updateError={this.props.updateError}
							contentText={'請設定此清單的名稱'}
							formdata={true}
						>
							{({toggleNameSet}) => (
								<button className='add-list' onClick={toggleNameSet}>建立文章清單</button>
							)}
						</CreateItem>
						<div className='popup-modal-filter-author'>
							<FormGroup check>
								<Label check>
									<Input type="radio" name="radio1" checked={this.state.filterType===1 ? true : false} onChange={() => {this.setType(1)}}/>
									僅搜尋所選擇的文章列表
								</Label>
							</FormGroup>
							<FormGroup check>
								<Label check>
									<Input type="radio" name="radio2" checked={this.state.filterType===2 ? true : false} onChange={() => {this.setType(2)}}/>
									排除所選擇的文章列表
								</Label>
							</FormGroup>
						</div>
					</div>

					<div className='my-search popup-filter'>
						<div className='my-search-sidebar max-heigh-sidebar'>
							{this.props.myArticleGroups.length > 0 ?
								<ul>
									{this.props.myArticleGroups.map( (obj, index) =>
										<li className={`my-media-title title-selected-${this.props.selectedArticle[index]}`} key={index}>
											<a onClick={() => this.select(obj.id, index)}>
												{decodeURIComponent(obj.name)}
											</a>
											<div>
												<UpdateItem
													apiCall={`${keywordApi}/update_doclist`}
													fetchItem={this.props.fetchMyArticles}
													updateError={this.props.updateError}
													contentText={'重新命名此文章列表的名稱'}
													formdata={true}
													notEncodeName={true}
												>
													{({toggleRename}) => (
														<i className='icon-pencil icons lowi-icon widget-tip' onClick={() => toggleRename(obj.id, obj.name)}>
															<span className="widget-tiptext">重新命名</span>
														</i>
													)}
												</UpdateItem>
												<DeleteItem
													apiCall={`${keywordApi}/delete_doclist`}
													fetchItem={this.props.fetchMyArticles}
													updateError={this.props.updateError}
													setInit={()=> this.setState({currArticle: false})}
													formdata={true}
												>
													{({toggleDelete}) => (
														<i className='icon-trash icons lowi-icon widget-tip' onClick={() => toggleDelete(obj.id, obj.name)}>
															<span className="widget-tiptext">刪除</span>
														</i>
													)}
												</DeleteItem>
											</div>
										 </li>
										)}
									</ul> :
									<div>您尚未建立任何文章清單</div>
								}
							</div>

							<div className='set search-result'>
								<Loader show={this.state.loading} message={spinner}>
									{Array.isArray(this.state.currArticles) ?
										this.state.currArticles.length > 0 ?
											<div className='filter-container max-heigh-container'>
												{this.state.currArticles.map((article, index) =>
													<div className='filter__badge neutral' key={index}>
														{article.name}
														<DeleteItem
															apiCall={`${keywordApi}/delete_doc_from_doclist`}
															fetchItem={() => this.select(this.state.currId, this.state.currDocIndex)}
															updateError={this.props.updateError}
															formdata={true}
															setInit={()=> {}}
														>
															{({toggleDelete}) => (
																<i className='fa fa-close lowi-icon' onClick={() => toggleDelete(article.id, article.name)}></i>
															)}
														</DeleteItem>
													</div>
												)}
											</div>

											: <div>此清單是空的</div>
										: null
									}
								</Loader>
							</div>
						</div>

					<div className="popup-modal-buttonset">
						<button className="cancel" onClick={this.cancel}>
							取消
						</button>
						<button className="apply" onClick={this.apply}>
							套用至搜尋條件
						</button>
					</div>

				</div>
				<Modal size='sm' isOpen={this.state.emptyAlert} toggle={this.toggleEmptyAlert}>
					<div className="popup-modal">
						<div className="popup-modal-content">
							您未選擇任何文章
							<div className="popup-modal-buttonset">
								<button className="apply" onClick={this.toggleEmptyAlert}>
									確定
								</button>
							</div>
						</div>
					</div>
				</Modal>
      </div>
    );
  }
}

const MyArticle = connect(mapStateToProps, mapDispatchToProps)(MyArticleComponent);

export default withRouter(MyArticle);



// WEBPACK FOOTER //
// ./src/components/popup/myArticle.js